import { useParams } from 'react-router-dom';
import { Chains } from 'api/types/httpsTypes/d-wallets';
import {
  useLastVisitedAddress,
  useLastVisitedChain,
} from '../../snipeContainer';
import { useEffect } from 'react';

export function useCacheLastVisitedAddress() {
  const { chain, address } = useParams<{ chain: Chains; address: string }>();
  const [lastVisitedAddress, setAddress] = useLastVisitedAddress();
  const [lastVisitedChain, setChain] = useLastVisitedChain();

  useEffect(() => {
    if (chain && address) {
      setAddress(address);
      setChain(chain);
    }
  }, [chain, address]);

  return {
    chain: chain ?? lastVisitedChain,
    address: address ?? lastVisitedAddress,
  };
}
